<template>
    <el-dialog
        v-model="visible"
        :title="title"
        width="90%"
        class="missing-profile-requirements-modal"
        @close="onClose"
    >
        <p class="missing-profile-requirements-modal__intro">
            {{ introText }}
        </p>
        <ul class="missing-profile-requirements-modal__list">
            <li
                v-for="item in missing"
                :key="item.key"
                class="missing-profile-requirements-modal__item"
            >
                <span class="missing-profile-requirements-modal__label">{{ getItemLabel(item) }}</span>
                <el-button
                    type="primary"
                    size="small"
                    @click="onComplete(item)"
                >
                    Complete
                </el-button>
            </li>
        </ul>
        <template #footer>
            <el-button @click="onClose">Close</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { ElDialog, ElButton } from 'element-plus';
import {
    isAbnGroupItem,
    isBillingGroupItem,
    isSuperGroupItem,
} from '@/helpers/profile/groupProfileRequirements.js';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    missing: {
        type: Array,
        default: () => [],
    },
    title: {
        type: String,
        default: 'Complete your profile details',
    },
    isApplyJob: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue', 'complete']);

const visible = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
});

const introText = computed(() =>
    props.isApplyJob
        ? 'Please complete the following details before applying for this shift:'
        : 'Please complete the following details before accepting this shift:'
);

const onClose = () => {
    visible.value = false;
};

const onComplete = (item) => {
    emit('complete', item);
};

function getItemLabel(item) {
    if (isAbnGroupItem(item)) {
        return 'ABN information is missing';
    }
    if (isBillingGroupItem(item)) {
        return 'Billing information is missing';
    }
    if (isSuperGroupItem(item)) {
        return 'Superannuation information is missing';
    }
    return item.label;
}
</script>

<style scoped lang="scss">
.missing-profile-requirements-modal__intro {
    margin: 0 0 16px;
}

.missing-profile-requirements-modal__list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.missing-profile-requirements-modal__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid var(--el-border-color-lighter);

    &:last-child {
        border-bottom: none;
    }
}

.missing-profile-requirements-modal__label {
    color: rgb(var(--locumate-clr-danger));
}
</style>
